export const locale = {
  lang: 'es',
  data: {
    CENTER_MANAGEMENT: {
      "TITLE": "Usuarios",
      "INTRO": "Administra los usuarios de tu centro.",
      "USERS": "Usuarios",
      "DETAILS": "Datos del centro",
      "PDF": "Personalización del PDF",
      "INVITE": "Invitar usuario",
      "EDIT": "Editar usuario",
      "NAME": "Nombre",
      "LAST_NAME": "Apellidos",
      "EMAIL": "Correo electrónico",
      "ROLE": "Rol",
      "EMPLOYEE": "Usuario",
      "ADMIN": "Administrador del centro",
      "STATUS": "Estado",
      "ACTIONS": "Acciones",
      "INVITE_HELP": "Enviaremos un enlace válido durante 7 días para que configure su contraseña.",
      "EMAIL_HELP": "El correo identifica la cuenta. Para otra dirección, desactiva esta cuenta e invita a la nueva.",
      "CONFIRM_ROLE": "Este cambio modifica los permisos de gestión del centro. ¿Quieres continuar?",
      "CONFIRM": "Confirmar",
      "SAVE": "Guardar",
      "CANCEL": "Cancelar",
      "CONFIRM_ACTIVATE": "¿Quieres reactivar el acceso de este usuario?",
      "CONFIRM_DEACTIVATE": "Se bloqueará el acceso y se cancelará cualquier invitación pendiente. ¿Quieres desactivar a este usuario?",
      "SEARCH": "Buscar por nombre o correo",
      "SEARCH_BUTTON": "Buscar",
      "LOADING": "Cargando usuarios…",
      "RESEND": "Reenviar invitación",
      "REVOKE": "Cancelar invitación",
      "DEACTIVATE": "Desactivar",
      "ACTIVATE": "Reactivar",
      "EMPTY": "No hay usuarios que coincidan con la búsqueda.",
      "EMPTY_INITIAL": "Todavía no hay usuarios",
      "EMPTY_HELP": "Invita a tu equipo para darle acceso a tu centro.",
      "EMPTY_SEARCH_HELP": "Prueba con otro nombre o correo electrónico.",
      "COUNT_ONE": "{{ count }} usuario",
      "COUNT_OTHER": "{{ count }} usuarios",
      "PREVIOUS": "Anterior",
      "NEXT": "Siguiente",
      "active": "Activo",
      "inactive": "Inactivo",
      "invited": "Invitación pendiente",
      "expired": "Invitación caducada",
      "revoked": "Invitación cancelada",
      "EMAIL_FAILED": "La cuenta se ha guardado, pero no se ha podido enviar el correo. Puedes reenviar la invitación.",
      "INVITED_OK": "Invitación enviada.",
      "SAVED": "Cambios guardados.",
      "EMAIL_EXISTS": "Ya existe un usuario con esta dirección de correo electrónico.",
      "ERROR": "No se ha podido completar la operación. Inténtalo de nuevo.",
      "ACCEPT_TITLE": "Únete a tu centro",
      "ACCEPT_HELP": "Configura tu contraseña para activar la cuenta y acceder a tu centro.",
      "ACCEPTED": "Tu cuenta está activada. Ya puedes iniciar sesión.",
      "LOGIN": "Iniciar sesión",
      "PASSWORD": "Contraseña",
      "PASSWORD_HELP": "Usa al menos 8 caracteres, una mayúscula y un número.",
      "REPEAT_PASSWORD": "Repite la contraseña",
      "PASSWORD_MISMATCH": "Las contraseñas no coinciden.",
      "ACCEPT_BUTTON": "Activar cuenta"
},
    TRANSLATOR: {
      SELECT: 'Seleccionar idioma',
    },
    GENERAL: {
      COMPANY_NAME: 'Kiubo Studios SL',
      LOADING: 'Por favor espera...',
      CONTINUE: 'Continuar',
      ABOUT: 'Acerca de',
      CONTACT: 'Contacto',
      EMAIL: 'Email',
      EMAIL_PLACEHOLDER: 'Escribe tu email',
      PASSWORD: 'Contraseña',
      PASSWORD_PLACEHOLDER: 'Escribe tu contraseña',
      SHOW_PASSWORD: 'Mostrar contraseña',
      HIDE_PASSWORD: 'Ocultar contraseña',
      NAME: 'Nombre',
      CANCEL: 'Cancelar',
      CLOSE: 'Cerrar',
      RETRY: 'Reintentar',
      UPDATING: 'Actualizando…',
    },
    MENU: {
      TUTORIALS: 'Tutoriales',
      VERSION: 'Versión {{version}}',
      NAVIGATION: 'Navegación del Game Center',
      COLLAPSE_SIDEBAR: 'Contraer menú lateral',
      EXPAND_SIDEBAR: 'Expandir menú lateral',
      GAME_SECTION: 'Partidas',
      CONFIG_SECTION: 'Configuración',
      MANAGEMENT_SECTION: 'Gestión',
      ADMIN_SECTION: 'Administración',
    },
    PAGINATOR: {
      LABEL: 'Paginación',
      ITEMS_PER_PAGE: 'Elementos por página',
      PER_PAGE: '{{count}} por página',
      PREVIOUS: 'Página anterior',
      NEXT: 'Página siguiente',
      PAGE: 'Página {{page}}',
      SUMMARY: {
        GAME_ONE: 'Mostrando del {{first}} al {{last}} de {{count}} partida',
        GAME_OTHER: 'Mostrando del {{first}} al {{last}} de {{count}} partidas',
        VIDEO_ONE: 'Mostrando del {{first}} al {{last}} de {{count}} vídeo',
        VIDEO_OTHER: 'Mostrando del {{first}} al {{last}} de {{count}} vídeos',
        USER_ONE: 'Mostrando del {{first}} al {{last}} de {{count}} usuario',
        USER_OTHER: 'Mostrando del {{first}} al {{last}} de {{count}} usuarios',
      },
      TOTAL: {
        GAME_ONE: '{{count}} partida',
        GAME_OTHER: '{{count}} partidas',
        VIDEO_ONE: '{{count}} vídeo',
        VIDEO_OTHER: '{{count}} vídeos',
        USER_ONE: '{{count}} usuario',
        USER_OTHER: '{{count}} usuarios',
      },
    },
    CATALOG: {
      TITLE: 'Design Catalog',
      SURFACE_TITLE: 'Referencia de interfaz',
      DESCRIPTION: 'Vista de referencia para diseño y QA. Visible únicamente en entornos que no sean producción.',
      ENVIRONMENT: 'entorno',
      INPUT: 'Campo de texto',
      SELECT: 'Selector',
      TYPE_SOMETHING: 'Escribe algo',
      TOGGLE_DESCRIPTION: 'Interruptor con estilo Kiubo (consulta styles.scss)',
      BRAND_FONT: 'tipografía personalizada para títulos de marca',
      ICON_BUTTON_STATES: 'estados neutro, cargando y destructivo',
      HOVER_ME: 'Pasa el cursor',
      ALIGN_END: 'Alinear al final',
      NOTIFICATION_DESCRIPTION: 'Usa estos botones para emitir una notificación de prueba mediante la barra global de notificaciones.',
      ERROR_MOCK: 'vista previa del 404',
      PAGE_NOT_FOUND: 'Página no encontrada',
      SYSTEM_ERROR: 'Error del sistema',
      NOT_FOUND_MESSAGE: 'No hemos encontrado lo que buscabas.',
      DISABLED: 'deshabilitado',
      ARCHIVE: 'Archivar',
      EXAMPLE_TOGGLE: 'Interruptor de ejemplo',
      FORM_ERROR: 'mensaje de error del formulario',
      NEUTRAL: 'neutro',
      CENTERED_TOOLTIP: 'Ayuda contextual centrada',
      END_TOOLTIP: 'Ayuda contextual alineada al final',
      ERROR: 'Error',
      ERROR_PREVIEWS: 'Vistas previas de páginas de error',
      NAV: {
        LABEL: 'Secciones del Design Catalog', COLORS: 'Colores', FOUNDATIONS: 'Fundamentos',
        COMPONENTS: 'Componentes', REFERENCE: 'Referencia', ERRORS: 'Estados de error',
      },
      TYPE_USAGE: {
        DISPLAY: 'Cifras destacadas y mensajes principales', PAGE_TITLE: 'Título principal de página',
        COMPONENT_TITLE: 'Tarjetas y encabezados de componentes', BODY_MEDIUM: 'Texto de interfaz enfatizado',
        BODY: 'Texto de interfaz predeterminado', CAPTION: 'Metadatos y etiquetas secundarias',
      },
      SECTIONS: {
        BRAND_PALETTE: 'Paleta de marca',
        STATES_NEUTRALS: 'Estados y colores neutros',
        TYPOGRAPHY: 'Tipografía',
        BUTTONS: 'Botones',
        FORMS: 'Formularios',
        INFO_ROW: 'Fila informativa',
        BADGES: 'Insignias',
        NOTIFICATIONS: 'Notificaciones',
        CARD_TABLE: 'Tabla de datos',
        PAGINATOR: 'Paginador',
        ASIDE_ICONS: 'Iconos del menú lateral',
        COMPONENT_INVENTORY: 'Inventario de componentes',
        MAIN_PAGES: 'Páginas y módulos principales',
        AUTH_SCREENS: 'Autenticación · pantallas',
        STATIC_PAGES: 'Páginas estáticas',
        SHARED_COMPONENTS: 'Componentes compartidos',
        LAYOUT: 'Estructura (shell de Kiubo)',
        TOOLTIP: 'Ayuda contextual',
      },
      TABLE: {
        DESCRIPTION: 'Patrón compacto actual de la tabla, con estados de carga y vacío.',
        CAPTION: 'Ejemplo de clasificación',
        POSITION: 'Posición', PLAYER: 'Jugador', SCORE: 'Puntuación', MAX_WAVE: 'Oleada máxima', GAMES: 'Partidas',
        LOADING_STATE: 'Cargando', EMPTY_STATE: 'Vacía', EMPTY: 'No hay resultados que mostrar',
      },
      SWATCH: {
        CANVAS: 'Lienzo', NAV_HEADER: 'Navegación / cabecera', RAISED: 'Superficie elevada',
        SUNKEN_CONTROL: 'Superficie hundida / control', OVERLAY: 'Superposición', HIGHLIGHT: 'Realce KIUBO',
        PRIMARY_ACTION: 'Acción principal', PRIMARY_HOVER: 'Acción principal al pasar el cursor',
        SECONDARY_TEXT: 'Texto de acción secundaria', SUBTLE_BORDER: 'Borde sutil', DEFAULT_BORDER: 'Borde predeterminado',
        SUCCESS: 'Éxito', WARNING: 'Aviso', DANGER: 'Peligro', INFO: 'Información',
        PRIMARY_TEXT: 'Texto principal', SECONDARY_CONTENT: 'Texto secundario',
        TERTIARY_TEXT: 'Texto terciario', DISABLED_TEXT: 'Texto deshabilitado',
      },
      USAGE: {
        APP_BACKGROUND: 'Fondo de la aplicación', SHELL_SURFACES: 'Superficies persistentes de la aplicación',
        CARDS_PANELS: 'Tarjetas y paneles', INPUTS_NESTED: 'Campos y áreas anidadas',
        FLOATING_SURFACES: 'Menús y superficies flotantes', BRAND_EMPHASIS: 'Énfasis de marca y cabeceras',
        PRIMARY_ACTIONS: 'Acciones principales y selección', PRIMARY_HOVER: 'Acción principal al pasar el cursor',
        SECONDARY_TEXT: 'Texto interactivo secundario', SUBTLE_BORDER: 'Separación de bajo énfasis',
        DEFAULT_BORDER: 'Separación de superficies', SUCCESS: 'Estado semántico positivo', WARNING: 'Estado semántico de aviso',
        DANGER: 'Estado semántico de peligro', INFO: 'Estado semántico informativo', IMPORTANT_CONTENT: 'Contenido importante',
        SUPPORTING_CONTENT: 'Contenido complementario', METADATA: 'Metadatos y descripciones', UNAVAILABLE_CONTENT: 'Contenido no disponible',
      },
    },
    DASHBOARD: {
      KICKER: 'Sesiones en vivo',
      TITLE: 'Partidas activas',
      SURFACE_TITLE: 'Sesiones en vivo',
      TAGLINE_PRIMARY: 'Jugadores reales.',
      TAGLINE_SECONDARY: 'Mundos reales.',
      ROOM_NAME: 'Nombre de la partida',
      ROOM_EDIT: 'Nombre de la partida',
      CREATED_AT: 'Hora inicio',
      PROGRESS: 'Progreso',
      NUM_GAMES: 'Mapas jugados',
      HIDE: 'Mover al Historial',
      SUCCESS_NAME: 'El nombre de la partida se ha modificado correctamente',
      ERROR_NAME: 'No se ha podido modificar el nombre de la partida',
      ERROR_PDF_TITLE: 'No se pudo generar el PDF',
      ERROR_PDF_MESSAGE: 'Inténtalo de nuevo.',
      SUCCESS_DISABLE_ROOM: 'Se ha ocultado la partida',
      SUCCESS_ENABLE_ROOM: 'Se ha desarchivado la partida',
      SUCCESS_ENABLE_ROOM_TITLE: 'Partida desarchivada',
      SUCCESS_ENABLE_ROOM_MESSAGE: 'La partida vuelve a estar disponible.',
      SUCCESS_DISABLE_STATION: 'Se ha archivado la estación',
      SUCCESS_RENAME_STATION: 'Se ha renombrado la estación',
      ERROR_DISABLE_ROOM: ' No se ha podido ocultar la partida',
      ERROR_ENABLE_ROOM: 'No se ha podido desarchivar la partida',
      SUCCESS_DISABLE_ROOM_LIST: 'Se han ocultado las partidas seleccionadas',
      ERROR_DISABLE_ROOM_LIST: ' No se han podido ocultar las partidas seleccionadas',
      SUCCES_REDIRECT: 'Volver a la página principal',
      LOADING: 'Cargando',
      LOAD_ERROR: 'No se han podido cargar las partidas activas.',
      NUM_PLAYERS: 'Jugadores',
      ROOMS_EMPTY: 'No hay partidas disponibles para mostrar',
      ROOMS_EMPTY_IMAGE_ALT: 'No hay partidas activas',
      DOWNLOAD: 'Descargar',
      DOWNLOAD_PDF: 'Descargar PDF',
      DOWNLOAD_PDF_FOR: 'Descargar PDF de {{room}}',
      ARCHIVE: 'Archivar',
      MOVE_TO_HISTORY: 'Mover al historial',
      MOVE_TO_HISTORY_FOR: 'Mover {{room}} al historial',
      MOVE_SELECTED_TO_HISTORY: 'Mover seleccionadas al historial',
      GAMES_SELECTED_ONE: '{{count}} partida seleccionada',
      GAMES_SELECTED_OTHER: '{{count}} partidas seleccionadas',
      ARCHIVE_SELECTED_GAME_ONE: 'Archivar {{count}} partida seleccionada',
      ARCHIVE_SELECTED_GAME_OTHER: 'Archivar {{count}} partidas seleccionadas',
      SELECT_ALL_ROOMS: 'Seleccionar todas las partidas',
      SELECT_ROOM: 'Seleccionar {{room}}',
      OPEN_ROOM_DETAILS: 'Ver detalles de {{room}}',
      VIEW_DETAILS: 'Ver detalles',
      EDIT_ROOM_NAME: 'Editar el nombre de la partida {{room}}',
      EDIT_PLAYER_NAME: 'Editar el nombre de {{player}}',
      PLAYER_NAME_SCOPE: 'Se aplica a todos los juegos de esta partida.',
      PLAYER_NAME_ERROR_TITLE: 'No se ha podido cambiar el nombre',
      PLAYER_NAME_ERROR: 'No se ha guardado el nombre. Inténtalo de nuevo.',
      PLAYER_NAME_CONFLICT: 'Otro jugador de esta partida ya utiliza ese nombre.',
      ROOM_ID: 'ID: {{id}}',
      ACTIONS: 'Acciones',
      ROOM_DETAIL_TABLE: 'Puntuaciones de jugadores',
      ROOM_DETAIL_EMPTY: 'No hay puntuaciones de jugadores disponibles',
      ROOM_DETAIL_ERROR: 'No se han podido cargar las puntuaciones',
      SELECT_ROOMS_TO_HISTORY: 'Selecciona partidas para mover al historial',
      PLAYER_NAME: 'Nombre del jugador',
      SCORE: 'Puntuación',
      POSITION: 'Posición',
      PLAYERS_ONE: '{{count}} jugador',
      PLAYERS_OTHER: '{{count}} jugadores',
      MAPS_PLAYED_ONE: '{{count}} mapa jugado',
      MAPS_PLAYED_OTHER: '{{count}} mapas jugados',
    },
    ROOM_HISTORICAL: {
      GROUP_COUNT_ONE: '{{count}} partida',
      GROUP_COUNT_OTHER: '{{count}} partidas',
      INVALID_DATE: 'Introduce una fecha válida con el año de cuatro cifras (AAAA-MM-DD).',
      TITLE: 'Historial de partidas',
      EMPTY: 'No hay histórico disponible',
      EMPTY_IMAGE_ALT: 'Ilustración de histórico vacío',
      RESTORE: 'Restaurar partida',
      RESTORE_FOR: 'Restaurar {{room}}',
      TABLE_CAPTION: 'Partidas archivadas',
      FILTERS: 'Filtrar historial de partidas',
      DATE_FILTER: 'Fecha',
      DATE_PLACEHOLDER: 'Cualquier rango de fechas',
      SEARCH_PLACEHOLDER: 'Buscar por nombre de partida',
      OPEN_CALENDAR: 'Abrir calendario',
      HOUR_FILTER: 'Hora',
      ALL_DAY: 'Todo el día',
      CLEAR_FILTER: 'Limpiar filtro',
      LOAD_ERROR: 'No se ha podido cargar el historial de partidas.',
    },
    STATIONS:{
      TITLE: 'Estaciones',
      SURFACE_TITLE: 'Estaciones registradas',
      NAME: 'Nombre de la estación',
      EDIT_NAME: 'Editar el nombre de la estación {{station}}',
      DEVICE_ID: 'ID del dispositivo',
      TYPE: 'Tipo',
      LAST_USED: 'Último uso',
      LEGACY: 'Anterior',
      TYPE_GAME_BOOTH: 'Estación de juego',
      TYPE_STATION: 'Estación de juego',
      TYPE_UNKNOWN: 'Desconocido',
      NEVER: 'Nunca',
      ARCHIVE: 'Archivar estación',
      ARCHIVE_FOR: 'Archivar {{station}}',
      TABLE_CAPTION: 'Estaciones',
      EMPTY: 'No hay estaciones registradas',
      EMPTY_IMAGE_ALT: 'No hay estaciones registradas',
      LOAD_ERROR: 'No se han podido cargar las estaciones.',
    },
    HELP: {
      TITLE: 'Ayuda',
      LOAD_ERROR: 'No se ha podido cargar el contenido de ayuda.',
      DESCRIPTION: 'Tutoriales cortos y vídeos rápidos para ayudarte a operar KIUBO.',
      COMMUNITY: {
        TITLE: 'Comunidad',
        DESCRIPTION: 'Únete a la comunidad, haz preguntas y comparte feedback.',
        ACCESS_DESCRIPTION: 'Accede a la comunidad privada de KIUBO con tu sesión activa de la plataforma.',
        OPEN: 'Abrir comunidad',
        DEMO_DENIED: 'Las cuentas demo no pueden acceder a la comunidad privada.',
      },
      PLAY: 'Reproducir vídeo',
    },
    LEADERBOARD: {
      TITLE: 'Clasificación',
      LOAD_ERROR: 'No se ha podido cargar la clasificación.',
      SURFACE_TITLE: 'Mejores jugadores de {{centerName}}',
      SUBTITLE_LIVE: 'Mejores jugadores de {{centerName}}',
      POSITION: 'Posición',
      PLAYER: 'Jugador',
      SCORE: 'Puntuación',
      GAMES_PLAYED: 'Partidas jugadas',
      MAX_WAVE: 'Oleada máxima',
      WORLD_MAX_WAVE: 'Oleada máxima alcanzada en el mundo',
      CENTER_MAX_WAVE: 'Oleada máxima alcanzada en {{centerName}}',
      WORLD_RECORD: 'Récord mundial',
      CENTER_RECORD: 'Récord de {{centerName}}',
      OPEN_FULLSCREEN: 'Abrir en pantalla completa',
      EMPTY: 'Todavía no hay puntuaciones registradas',
      POWERED_BY: 'Con tecnología de',
    },
    REGISTER_BOOTH: {
      TITLE: "Registro de cabina",
      DESCRIPTION: "Completa el proceso de registro de tu cabina",
      SUCCESS: 'Tu cabina ha sido registrada correctamente',
      ERROR: 'No se ha podido registrar tu cabina',
      NAME: 'Nombre de la cabina',
      NAME_PLACEHOLDER: 'Escribe el nombre de la cabina',
      INVALID_TOKEN: 'Ha ocurrido un error, por favor intentalo de nuevo',
    },
    USER: {
      LOG_OUT: 'Cerrar sesión'
    },
    AUTH: {
      PROFILE: {
        PERSONAL_DATA: 'Datos personales',
        NAME_REQUIRED: 'Tu nombre es obligatorio',
        LASTNAME_REQUIRED: 'Tu apellido es obligatorio',
        NAME_LENGTH: 'Tu nombre debe tener al menos {{ qty }} caracteres',
        LASTNAME_LENGTH: 'Tu apellido debe tener al menos {{ qty }} caracteres',
        CENTER_DATA: 'Datos del Centro',
        SCORE_EDITOR_DATA: 'Editor de Ticket',
        NAME: 'Nombre completo',
        NAME_PLACEHOLDER: 'Nombre',
        LAST_NAME_PLACEHOLDER: 'Apellido',
        EMAIL: 'Correo electrónico',
        EMAIL_PLACEHOLDER: 'Correo electrónico',
        EMAIL_REQUIRED: 'El correo electrónico es obligatorio',
        ALLOW_MARKETING: 'Permitir marketing',
        EMAIL_INVALID:  'Formato de email invalido',
        PROFILE_UPDATED: 'Perfil actualizado correctamente',
        SCORE_EDITOR: {
          TITLE: 'Vista previa',
          DESCRIPTION: 'Así se verá el ticket con la configuración actual.',
          DOWNLOAD_PREVIEW: 'Descargar vista previa',
          DOWNLOADING: 'Preparando PDF…',
          DOWNLOAD_ERROR: 'No se ha podido descargar la vista previa',
          CHANGE_IMAGE: 'Cambiar imagen del centro',
          CLICK_TO_ADD_USER: 'Haz clic para añadir un usuario',
          SLOGAN_LABEL: 'Eslogan del ticket',
          SAVE_HINT: 'Pulsa Enter o el check para guardar',
          SAVE_CHANGES: 'Guardar cambios',
          CENTER_IMAGE_UPDATED: 'La imagen del centro se ha guardado correctamente',
          CENTER_IMAGE_REQUIREMENTS: 'PNG o JPG · Máximo 2 MB y 2000 × 2000 px',
          CENTER_IMAGE_INVALID_FORMAT: 'Formato no válido. Selecciona una imagen PNG o JPG.',
          CENTER_IMAGE_TOO_LARGE: 'La imagen supera el tamaño máximo de 2 MB.',
          CENTER_IMAGE_DIMENSIONS_TOO_LARGE: 'La imagen supera las dimensiones máximas de 2000 × 2000 px.',
          CENTER_IMAGE_INVALID: 'No se ha podido leer la imagen. Selecciona un archivo PNG o JPG válido.',
          CENTER_IMAGE_FORBIDDEN: 'No tienes permisos para cambiar la imagen de este centro.'
        },
        CENTER: {
          OVERVIEW: 'Perfil del centro',
          FISCAL_DATA: 'Datos fiscales',
          FISCAL_DATA_DESCRIPTION: 'Información legal y dirección de facturación del centro.',
          PUBLIC_DATA: 'Información pública',
          PUBLIC_DATA_DESCRIPTION: 'Datos visibles para identificar y encontrar tu centro.',
          READ_ONLY: 'Solo lectura',
          OPTIONAL: 'opcional',
          NAME: 'Nombre',
          NAME_REQUIRED: 'El nombre de tu centro es obligatorio',
          WEB_REQUIRED: 'El campo de tu web es obligaorio',
          WEB_INVALID: 'El formato de web es incorrecto (http://example.com)',
          FB_INVALID: 'El formato de Facebook es incorrecto (http://facebook.com/example)',
          NAME_PLACEHOLDER: 'Nombre de tu centro',
          WEB_PLACEHOLDER: 'Web de tu centro',
          NAME_LENGTH: 'Nombre de tu centro debe tener al menos {{ qty }} caracteres',
          CHARACTERES: 'caracteres',
          VAT: 'CIF',
          VAT_PLACEHOLDER: 'CIF de tu centro',
          ADDRESS_1: 'Dirección 1',
          ADDRESS_1_PLACEHOLDER: 'Dirección 1',
          ADDRESS_2: 'Dirección 2',
          ADDRESS_2_PLACEHOLDER: 'Dirección 2',
          POSTAL_CODE: 'Código Postal',
          POSTAL_CODE_PLACEHOLDER: 'Código Postal',
          COUNTRY: 'País',
          COUNTRY_ES: 'España',
          WEB: 'Web',
          FACEBOOK: 'Facebook',
          FACEBOOK_PLACEHOLDER: 'Facebook de tu centro, para seguirte ;P',
          SLOGAN: 'Slogan',
          SLOGAN_PLACEHOLDER: 'Eslogan de tu centro',
          CENTER_UPDATED: 'Centro actualizado correctamente',
          SUPPORT_TITLE: '¿Necesitas modificar estos datos?',
          CANNOT_EDIT: 'Solicita el cambio al equipo de Soporte Técnico.',
          CONTACT_SUPPORT: 'Contactar con soporte',
          SLOGAN_TOO_LONG: "El slogan no puede tener más de {{ qty }} caracteres.",
          SLOGAN_EMPTY: 'El eslogan no puede estar vacío',
          SLOGAN_UPDATED: 'Slogan actualizado correctamente',
          SLOGAN_ERROR: 'Error al actualizar el eslogan',
          IMAGE_UPDATED: 'Imagen actualizada correctamente',
        },
      },
      GENERAL: {
        SUBMIT_BUTTON: 'Enviar',
        NO_ACCOUNT: '¿No tienes una cuenta?',
        SIGNUP_BUTTON: 'Regístrate',
        FORGOT_BUTTON: '¿Olvidaste tu contraseña?',
        PRIVACY: 'Privacidad',
        LEGAL: 'Legal',
        CONTACT: 'Contacto',
        SAVE: 'Guardar'
      },
      LOGIN: {
        TRY: '¿Quieres probar la plataforma?',
        WELCOME: 'Bienvenid@ a GameCenter',
        NOT_ACCOUNT: '¿No tienes cuenta?',
        TITLE: 'Crear una cuenta',
        BUTTON: 'Registrarse',
        USE_DEMO: 'Usar cuenta demo',
      },
      COMMUNITY_CONNECT_ERROR: 'No se ha podido iniciar sesión en la comunidad',
      LEGAL_ACCEPTANCE: {
        TITLE: 'Condiciones legales actualizadas',
        INTRO: 'Revisa y acepta los documentos actualizados para continuar usando KIUBO.',
        LOADING: 'Cargando…',
        DOCUMENT_META: 'Versión {{version}} · En vigor desde el {{date}}',
        CONSENT: 'He leído y acepto los documentos mostrados anteriormente.',
        SAVING: 'Guardando…',
        ACCEPT: 'Aceptar y continuar',
        SIGN_OUT: 'Cerrar sesión',
        LOAD_ERROR: 'No se han podido cargar los documentos legales.',
        SAVE_ERROR: 'No se ha podido guardar la aceptación. Inténtalo de nuevo.',
      },
      VERIFY_EMAIL: {
        DETAIL: 'Tu correo se ha verificado. Ya puedes iniciar sesión.',
      },
      SOCIAL: {
        OR: 'o continúa con',
        CONTINUE_WITH_GOOGLE: 'Continuar con Google',
        CONTINUE_WITH_FACEBOOK: 'Continuar con Facebook',
        SIGNING_IN: 'Iniciando sesión…',
      },
      FORGOT: {
        TITLE: '¿Olvidaste tu contraseña?',
        DESC: 'Introduce tu correo electrónico para restablecer tu contraseña',
        SENT: 'Se ha enviado la contraseña de restablecimiento. Por favor, revisa tu correo electrónico',
        SUCCESS: 'Tu cuenta se ha restablecido correctamente.'
      },
      PASSWORD_RESET: {
        TITLE: "Restablecer contraseña",
        DESC: "Introduce tu nueva contraseña",
        PASSWORD: "Contraseña",
        CONFIRM_PASSWORD: "Confirmar contraseña",
      },
      PASSWORD_RESET_SUCCESS: {
        TEXT: "Tu contraseña se ha modificado correctamente",
        ACTION: "Ir al inicio de sesión"
      },
      FORGOT_SUCCESS: {
        TEXT: "Se ha enviado un correo para restablecer la contraseña"
      },
      REGISTER: {
        TITLE: 'Registrarse',
        TITLE_2: 'Crea tu cuenta',
        ACCOUNT_STEP: 'Cuenta',
        CENTER_STEP: 'Game Center',
        STEP_ONE_OF_TWO: 'Paso 1 de 2',
        STEP_TWO_OF_TWO: 'Paso 2 de 2',
        ACCOUNT_STEP_HINT: 'Tus datos de acceso',
        CENTER_STEP_HINT: 'Los datos de tu negocio',
        CONTINUE: 'Continuar',
        BACK: 'Atrás',
        CENTER_TITLE: 'Háblanos de tu Game Center',
        CENTER_SUPPORT: 'Necesitamos algunos datos para configurar tu cuenta de KIUBO.',
        CREATE_ACCOUNT: 'Crear cuenta',
        PASSWORD_HELP: 'Usa al menos 8 caracteres, una mayúscula y un número.',
        REQUIRED_CONSENT: 'Obligatorio',
        OPTIONAL_CONSENT: 'Opcional',
        PROGRESS: 'Progreso del registro',
        MARKETING_CONSENT: 'Quiero recibir novedades de los productos KIUBO y comunicaciones comerciales.',
        NAME: 'Nombre',
        LAST_NAME: 'Apellido',
        HAVE_ACCOUNT: '¿Ya tienes una cuenta?',
        SIGN_IN: 'Iniciar sesión',
        DESC: 'Introduce tus datos para crear tu cuenta',
        SUCCESS: 'Tu cuenta se ha registrado correctamente.',
        CENTER_NAME: 'Nombre del centro',
        VAT: 'CIF',
        FACEBOOK: "Facebook",
        FACEBOOK_PLACEHOLDER: "Ingresa la URL de tu página de Facebook",
        WEB: "Sitio Web",
        WEB_PLACEHOLDER: "Ingresa la URL de tu sitio web",
        ADDRESS_1: 'Dirección 1',
        ADDRESS_2: 'Dirección 2',
        ADDRESS_2_OPTIONAL: 'Dirección 2 (opcional)',
        ADD_ADDRESS_2: 'Añadir segunda línea de dirección',
        EMAIL_EXISTS_INLINE: 'Ya existe una cuenta con este correo.',
        POSTAL_CODE: 'Código Postal',
        SELECT_COUNTRY: 'Seleccionar país',
        LEGAL_PRE: 'Acepto los',
        LEGAL: 'términos y condiciones',
        LEGAL_POST: 'y la',
        PRIVACY_POLICY: 'política de privacidad',
        SUPPORT_TEXT: 'Si tienes problemas con el registro, podemos ayudarte por correo.',
        SUPPORT_CTA: 'Escríbenos a kiubo.studios@gmail.com',
        TERMS_CONDITIONS_TITLE: 'Términos y Condiciones',
        PRIVACY_POLICY_TITLE: 'Política de Privacidad'
      },
      REGISTER_SUCCESS: {
        TITLE: 'Revisa tu correo',
        TEXT: 'Tu cuenta se ha creado correctamente.',
        DETAIL: 'Te hemos enviado un enlace para confirmar tu dirección de correo. Verifica tu dirección antes de iniciar sesión.',
        ACTION: 'Volver a iniciar sesión'
      },
      VERIFY_EMAIL_SUCCESS: {
        TEXT: "Su correo se ha validado correctamente",
        ACTION: "Ir al inicio de sesión"
      },
      INPUT: {
        FULLNAME: 'Nombre completo',
        PASSWORD: 'Contraseña',
        CONFIRM_PASSWORD: 'Confirmar contraseña',
        USERNAME: 'Usuario'
      },
      VALIDATION: {
        INVALID: '{{name}} no es válido',
        REQUIRED: '{{name}} es requerido',
        MIN_LENGTH: 'La longitud mínima de {{name}} es {{min}}',
        AGREEMENT_REQUIRED: 'Es necesario aceptar los términos y condiciones',
        NOT_FOUND: 'El {{name}} solicitado no se encuentra',
        INVALID_LOGIN: 'Los datos de inicio de sesión son incorrectos',
        REQUIRED_FIELD: 'Campo requerido',
        MIN_LENGTH_FIELD: 'Longitud mínima del campo:',
        MAX_LENGTH_FIELD: 'Longitud máxima del campo:',
        INVALID_FIELD: 'El campo no es válido',
        PASSWORD_NOT_MATCH: 'La contraseña y la confirmación no coinciden.',
        CONFIRM_PASSWORD: 'La confirmación de la contraseña no coincide con la contraseña.',
        PASSWORD_STRENGTH: 'Usa al menos 8 caracteres, una mayúscula y un número.',
      }
    },
    BOOTH: {
      TITLE: "Cabina"
    },
    ERROR: {
      AUTH_CREDENTIALS: 'Usuario o contraseña incorrectos',
      AUTH_EMAIL_VALIDATION: 'Correo electrónico no verificado. Si no ha recibido el correo, por favor escribe a kiubo.studios@gmail.com',
      AUTH_ACCOUNT_VALIDATION: 'Tu centro está siendo validado, si se demora la validación, escribe a kiubo.studios@gmail.com',
      AUTH_FORGOT: 'Lo siento, parece que se han detectado algunos errores, por favor intente de nuevo',
      BOOTH_NOT_CREATED: 'No se ha podido crear, comprueba tu conexión a Internet e inténtalo de nuevo. Si el problema persiste,  escribe a kiubo.studios@gmail.com',
      REGISTER: 'Los datos de registro son incorrectos',
      DEFAULT_VALIDATION: '{{field}} inválido',
      FORBIDDEN: 'Acceso no permitido',
      NOT_FOUND: 'No encontrado',
      UNKNOWN: '¡Vaya! Parece que tenemos un problema',
      NETWORK: 'Sin conexión a Internet. Comprueba la conexión e inténtalo de nuevo.',
      TIMEOUT: 'La solicitud ha tardado demasiado. Inténtalo de nuevo.',
      CONFLICT: 'Los datos han cambiado o entran en conflicto con otra operación. Actualiza e inténtalo de nuevo.',
      RATE_LIMIT: 'Demasiadas solicitudes. Espera un momento e inténtalo de nuevo.',
      SERVER: 'El servicio no está disponible temporalmente. Inténtalo de nuevo más tarde.',
      DEFAULT_EMPTY: 'No hay datos que mostrar',
      UNKNOWN_DESCRIPTION: 'Error desconocido o problema temporal, si el error persiste, por favor,  escribe a kiubo.studios@gmail.com',
      REQUIRED_FIELD: 'Por favor, completa el campo',
      PASSWORD_MISMATCH: 'Las contraseñas deben coincidir',
      INVALID_FORMAT_EMAIL: 'El formato del correo electrónico no es válido',
      MIN_LENGTH: 'Los caracteres minimos del campo son',
      ERROR_UPDATING: 'Error actualizando los datos, intenta de nuevo',
      INCORRECT_FORM: 'El formulario no es válido',
      AUTH_EMAIL_EXISTS: 'El correo electrónico ya está registrado',
      AUTH_OLD_PASSWORD_REQUIRED: 'La contraseña actual es requerida',
      AUTH_OLD_PASSWORD_INVALID: 'La contraseña actual es incorrecta',
      AUTH_TEMP_TOKEN_INVALID: 'El token temporal es inválido',
      AUTH_ERROR: 'Error',
      REGISTER_CREATE_FAILED: 'No hemos podido crear tu cuenta',
      REGISTER_CREATE_FAILED_DETAIL: 'Ha ocurrido un problema al crear tu cuenta. Inténtalo de nuevo.',
      AUTH_SOCIAL_DISABLED: 'El inicio de sesión social está deshabilitado.',
      AUTH_SOCIAL_NOT_CONFIGURED: 'El inicio de sesión social no está configurado en este entorno.',
      AUTH_SOCIAL_CANCELLED: 'El inicio de sesión social se canceló antes de terminar.',
      AUTH_SOCIAL_FAILED: 'No se pudo completar el inicio de sesión social. Inténtalo de nuevo.',
      AUTH_SOCIAL_TOKEN_INVALID: 'No se pudo verificar el token del proveedor.',
      AUTH_SOCIAL_EMAIL_MISSING: 'El proveedor no compartió un correo electrónico.',
      AUTH_SOCIAL_PROVIDER: 'Proveedor social no compatible.',
      INVALID_FACEBOOK_URL: "La URL de Facebook no es válida. Debe ser algo como 'https://www.facebook.com/tu-pagina'.",
      INVALID_URL: "La URL no es válida. Debe ser algo como 'https://www.tu-sitio.com'.",
      TERMS_CONDITIONS_REQUIRED: 'Debes aceptar los términos y condiciones para continuar'
    },
    PUBLIC_ERROR: {
      NOT_FOUND_TITLE: 'Página no encontrada',
      NOT_FOUND_DESCRIPTION: 'No hemos encontrado la página que buscabas.',
      SYSTEM_TITLE: 'Error del sistema',
      SYSTEM_DESCRIPTION: 'Algo ha salido mal. Inténtalo de nuevo más tarde.',
      GO_HOME: 'Ir a la página principal',
    }
  }
};
